var mp = mp || {};

// Slider - Testimonials
//-----------------------------------------------------------------
mp.sliderTestimonials = function () {
    var $slider = $(".testimonials__slider .slider");

    if (!$slider.length) {
        return;
    }

    $slick = $slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        fade: false,
        arrows: true,
        dots: false,
        speed: 1000,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        rows: 0,
        prevArrow:
            '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow:
            '<button type="button" class="slick-next slick-arrow"></button>',
        responsive: [
            {
                breakpoint: 920,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });
};

// Slider - Services
//-----------------------------------------------------------------
mp.sliderServices = function () {
    var $slider = $(".services__slider .slider");

    if (!$slider.length) {
        return;
    }

    $slick = $slider.slick({
        mobileFirst: true,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: false,
        arrows: true,
        dots: false,
        speed: 1200,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: "0px",
        centerMode: false,
        rows: 0,
        appendArrows: ".slider-arrows",
        prevArrow:
            '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow:
            '<button type="button" class="slick-next slick-arrow"></button>',
        responsive: [
            {
                breakpoint: 699,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1023,
                settings: "unslick",
            },
        ],
    });

    $slick.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        $slideIndex = currentSlide - nextSlide;

        $slider.find(".slick-current-temp").removeClass("slick-current-temp");

        if ($slideIndex > 1) {
            $currentSlide = $slider.find(".slick-current");
            $currentSlide.next().addClass("slick-current-temp");
        }

        if ($slideIndex < -1) {
            $currentSlide = $slider.find(".slick-current");
            $currentSlide.prev().addClass("slick-current-temp");
        }
    });
};

$(document).ready(function () {
    mp.sliderTestimonials();
    mp.sliderServices();
});
